import { defineNuxtPlugin, useRuntimeConfig } from "#imports";
import TagManager from "./TagManager.mjs";
export default defineNuxtPlugin((nuxtApp) => {
  let { public: { otsConnectors } } = useRuntimeConfig();
  otsConnectors = JSON.parse(JSON.stringify(otsConnectors));
  if (otsConnectors.tagManagerUID)
    TagManager.init(otsConnectors.tagManagerUID);
});
